export default __webpack_public_path__ + "static/media/goodreads.c4aa0a1e.png";